import { render, staticRenderFns } from "./score-accordion.vue?vue&type=template&id=3bbddb3c"
import script from "./score-accordion.vue?vue&type=script&lang=js"
export * from "./score-accordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports